import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './ProfileStatistic.module.scss'
import PieChartsLine from '../PieChartsLine/PieChartsLine'
import AllDataPercentage from '../AllDataPercentage/AllDataPercentage'
const ProfileStatistic = ({ data, data2 }) => {
  const { t } = useTranslation('common')
  return (
    <div className={styles.document_status_cards_wrapper}>
      <div className={styles.user_info_left}>
        <div className={styles.item_square_flex}>
          <div className={styles.item}>
            <p className={styles.title}>{t('statistic.employee')}</p>
            <p className={styles.descrip}>{data?.profile?.name}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>{t('statistic.email_short')}</p>
            <p className={styles.descrip}>{data?.profile?.email}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>{t('statistic.in_system_since')}</p>
            <p className={styles.descrip}>{data?.profile?.date_registration}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>{t('statistic.phone_label')}</p>
            <p className={styles.descrip}>{data?.profile?.phone_number}</p>
          </div>
          <div className={styles.item}>
            <p className={styles.title}>{t('statistic.position_label')}</p>
            <p className={styles.descrip}>{data?.profile?.position}</p>
          </div>
        </div>
      </div>
      <div className={styles.right_side_mobile}>
        <div className={styles.user_progress_middle}>
          <p className={styles.title} style={{ textAlign: 'center' }}>
            {t('statistic.progress')}
          </p>
          <PieChartsLine data={data?.threepie} />
        </div>

        <div className={styles.user_progress_bottom}>
          <AllDataPercentage data={data?.onepie} />
        </div>
      </div>
    </div>
  )
}

export default ProfileStatistic
